import {
	LOADING,
	LAZY_LOAD,
	LOGOUT,
	MiscActionTypes,
	SET_SHOW_BURGERMENU
} from './actionTypes';

interface MiscState {
	loading: {
		isLoading?: boolean;
		loadingMsg?: string;
	},
	lazyLoad: {
		[key: string]: boolean;
	};
	shouldPopup: boolean;
	showBurgerMenu: boolean;
}

const initState: MiscState = {
	loading: {
		isLoading: false,
		loadingMsg: '',
	},
	lazyLoad: {},
	shouldPopup: true,
	showBurgerMenu: true
};

const miscReducer = (state = initState, action: MiscActionTypes): MiscState => {
	switch (action.type) {
		case LOADING:
			return {
				...state,
				loading: {
					isLoading: action.data.isLoading,
					loadingMsg: action.data.loadingMsg
				}
			};

		case LAZY_LOAD:
			return {
				...state,
				lazyLoad: {
					...state.lazyLoad,
					[action.data.fieldName]: action.data.isLoading,
				},
			};

		case LOGOUT:
			return initState;

		case SET_SHOW_BURGERMENU:
			return {
				...state,
				showBurgerMenu: action.payload
			};

		default:
			return state;
	}
};

export default miscReducer;
